import { ChildAccountDisplayObject } from 'src/components/enterprise/Parents/Children/ParentChildAccountController/types';

export const resetFields = (
  childAccount: ChildAccountDisplayObject
): ChildAccountDisplayObject => {
  return {
    ...childAccount,
    isBeingEdited: false,
    isDisabled: false,
  };
};

export const resetChildAccountsDisplay = (
  childAccounts: ChildAccountDisplayObject[]
): ChildAccountDisplayObject[] => {
  return childAccounts.map((account) => {
    return resetFields(account);
  });
};
